import React, { useEffect,useState } from 'react'
import Main from '../../cpn/Main'
import { DatePicker, Flex, Image, Input, Space, Table } from 'antd';
import dayjs from 'dayjs';
import ExpenseEdit from './ExpenseEdit';
import ExpenseDel from './ExpenseDel';
import { useFeiyongListQuery } from '../../store/NeiZhangFeiYongApi';
import ExpenseAudit from './ExpenseAudit';
import ExpenseAuditCancle from './ExpenseAuditCancle';
import PageTitle from '../../cpn/PageTitle';
function ExpenseList() {
    const e_id = JSON.parse(localStorage.getItem('e_id'));
    const eu_id = JSON.parse(localStorage.getItem('eu_id'));
    const eu_name = JSON.parse(localStorage.getItem('eu_name'));
    const [query, setQuery] = useState({
            "fy_dsbzd_id" : '',
            "fy_month" : '',
            "fy_qy_id" : e_id,
            fy_content:'',
            fy_dsbzd_danhao:'',
            fy_amount:'',
            dsbzdsh_ysyfkh_name:'',
        });
    const { data, isSuccess, } = useFeiyongListQuery(query, {refetchOnMountOrArgChange: true});
    const [dataSource, setDataSource] = useState([]);
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            const formattedData = data.Result.map(item => ({
                key: item.fy_id,
                fy_amount: item.fy_amount,
                remark: item.fy_content,
                fy_uname: item.fy_uname,
                fy_ctime: item.fy_ctime,
                fy_dsbzd_danhao: item.fy_dsbzd_danhao,
                fy_date: item.fy_date,
                fy_type_id: item.fy_type_id,
                fy_type_name: item.fy_type_name,
                fy_shouzhi_id: item.fy_shouzhi_id,
                fy_fyt_name: item.fy_fyt_name,
                fy_image: item.fy_image,
                fysh_data: item.fysh_data,
                fy_uid: item.fy_uid,
                fy_danhao: item.fy_danhao,
            }));
            const sortedData = formattedData.sort((a, b) => new Date(b.fy_date) - new Date(a.fy_date));
            setDataSource(sortedData);
        }else{
            setDataSource([])
        }
    }, [data, isSuccess]);
    const columns = [
        {
            title: '报销类型',
            dataIndex: 'fy_fyt_name',
            width: '6%', // 设置合适的宽度
            key:'fy_fyt_name',           
        },    
        {
            title: '日期',
            dataIndex: 'fy_date',
            width: '8%', // 设置合适的宽度
            key:'fy_date',           
        },    
        {
            title: '金额',
            dataIndex: 'fy_amount',
            width: '8%', 
            key:'fy_amount',
            render:(text,record) => {
                if(record.fy_shouzhi_id==='3' && text){
                    return <span style={{color:'red'}}>￥{Math.abs(text).toFixed(2)}</span>
                }else{
                    return <span style={{color:'green'}}>￥{(Number(text)).toFixed(2)}</span>
                }
            }
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key:'remark',            
        },
        {
            title: '图片',
            dataIndex: 'fy_image',
            key:'fy_image',
            width: '10%',
            render:(text,record) => {
                let img
                if(record.fy_image){
                    img = record.fy_image.map((item,index) => <Image key={index} src={`/api/assets/images/application/${item}`} width={20} height={20} style={{border:'1px blue solid'}}/> )
                }
                return <Space>{img}</Space>
            }
        },
        {
            title: '编号',
            dataIndex: 'fy_danhao',
            width: '5%', 
            key:'fy_danhao',
        },    
        {
            title: '新增',
            dataIndex: 'fy_uname',
            width: '12%', 
            key:'fy_uname',
            render:(text,record) => {
                return <>{text} {record.fy_ctime}</>
            }
        },
        {
            title: '审核',
            dataIndex: 'fysh_data',
            width: '12%', 
            key:'fysh_data',
            render:(text) => { 
                if (!Array.isArray(text)) {
                    return null; // or return some default content
                }               
                return <>{text.map((item) => <div key={item.fysh_id}>{item.fysh_uname} {item.fysh_ctime}</div>)}</>
            }
        },
        {
            title: '操作',
            width: '15%', 
            key:'action',
            render:(_,record) => {
                console.log(e_id,eu_id,eu_name);
                
                let myAudit
                if(record.fysh_data){
                   myAudit = record.fysh_data.some(item => +item.fysh_uid === eu_id)
                }
                return <Space>
                    {(+record.fy_uid === eu_id && !record.fysh_data) && <ExpenseEdit fy_id={record.key} e_id={e_id} eu_id={eu_id} eu_name={eu_name}/>}
                    {(+record.fy_uid === eu_id && !record.fysh_data) && <ExpenseDel fy_id={record.key} />}
                    {!myAudit && <ExpenseAudit fy_id={record.key}  eu_id={eu_id} eu_name={eu_name} />}
                    {myAudit && <ExpenseAuditCancle fy_id={record.key}  eu_id={eu_id} eu_name={eu_name} />}
                </Space>
            }
        },
    ]
    return (
        <Main  selectedKeys={['/ArapRPList']}>
            <PageTitle title='费用报销单列表'/>
            <Flex align='center' style={{marginBottom:"10px"}} gap={10} justify='flex-start'>
                <Input 
                    onChange={(e) => {setQuery(prev => ({...prev, fy_content: e.target.value ? e.target.value : ''}))}}
                    placeholder='请输入备注关键字'
                    allowClear={true} 
                    style={{width:'155px'}}                           
                />
                <Input
                    onChange={(e) => {setQuery(prev => ({...prev, fy_amount: e.target.value ? e.target.value : ''}))}}
                    placeholder='请输入金额'
                    allowClear={true}          
                    style={{width:'145px'}}                                             
                />               
                <Input
                    onChange={(e) => {setQuery(prev => ({...prev, fy_ysyfkh_name: e.target.value ? e.target.value : ''}))}}
                    placeholder='请输入账单名称'
                    allowClear={true}          
                    style={{width:'145px'}}                                             
                />               
                <DatePicker
                    onChange={(e) => {
                        setQuery(prev => ({...prev, fy_month: e ? dayjs(e).format('YYYY-MM') : ''}))
                    }} 
                    picker="month"
                    value={query.fy_month ? dayjs(query.fy_month, 'YYYY-MM') : null}
                    allowClear={true}                            
                />              
            </Flex>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={{ 
                    showTotal:(total) => `共${total}条`,
                    pageSize: 50,
                    position:['bottomCenter'],
                    showSizeChanger:true,
                 }}
                footer={false}
                className="custom-table"
            />
        </Main>
    )
}

export default ExpenseList